import { useContext } from "react";
import { FilterStoreContext, getFilterContextValue } from "../../../common/components/filterStoreContext";


export const npsListFilterConfig = {
    key: 'npsList',
    isActiveProp: 'isNpsListSearchActive',
    setAction: 'nps-list',
    resetAction: 'rest-nps-list',
    setFilterProp: 'setNpsListFilters',
    resetFilterProp: 'resetNpsListFilters',
    initialValue: {
        pageNo: 0,
        query: '',
        sortBy: null,
        sortOrder: null,
    }
}

const useNpsFilterContext = () => {

    const contextValue = useContext(FilterStoreContext);

    return getFilterContextValue(contextValue, npsListFilterConfig)
}

export default useNpsFilterContext;